import React, { Component } from 'react'
import UserRow from '../Users/UserRow.js'
import _ from 'lodash'
import './sponsors.css'
import getLabel from '../../utilities/label.js'
import getMediaIcon from '../../utilities/mediaIcon.js'
import getMediaLabel from '../../utilities/mediaLabel.js'
import TitleBar from '../TitleBar'
import NoteForm from '../NoteForm'

export default class Sponsor extends Component {
  constructor(props) {
    super(props)
    const noteTakingStatus = this.props.location.state ? this.props.location.state.isTakingNotes : false
    const goBackToNoteIndex = noteTakingStatus
    const sponsor = this.getSponsor(props.match.params.id)
    this.state = {
      sponsor: sponsor,
      isTakingNotes: noteTakingStatus,
      goBackToNoteIndex: goBackToNoteIndex
    }
    this.props.setActiveTab('sponsors', false)
    this.toggleNote = this.toggleNote.bind(this)
    window.trackPage('SponsorDetailScreen', props.match.params.id)
  }

  componentDidMount() {
    // scroll to top
    window.scrollTo(0,0)
  }

  getSponsor(id) {
    return _.find(this.props.sponsors.sponsors, {id: parseInt(id, 10)})
  }

  getContacts(){
    const user_ids = _.map(this.state.sponsor.sponsor_contacts, function(speaker){ return speaker.user_id})
    const users = _.filter(this.props.users.event_users, function(user){
      return (_.indexOf(user_ids, user.user_id) > -1)
    })
    if(users.length === 0) {
      return (null)
    }
    const elements = []
    elements.push(
      <div key="contact_header">
        <br />
        <span className='blue-header'>
          <h4 key="sponsor-contacts">
            {getLabel({ key: 'contact', plural: users.length })}
          </h4>
        </span>
      </div>
    )
    _.each(users, function(user){
      elements.push(
        <div key={user.id}>
          <UserRow
            user={user}
            dimUsers={true}
            activeTab="sponsors" />
          <hr />
        </div>
      )
    })
    return elements
  }

  getMedia() {
    if(this.state.sponsor.attachments){
      const attachments = []
      _.each(this.state.sponsor.attachments, (attachment) => {
        attachments.push(
          <li key={ attachment.id }>
            <a href={attachment.url} target='_blank' rel='noopener noreferrer' className={'sponsor-attachment ' + attachment.type }>
              <span className="attachment-icon pull-left">{getMediaIcon(attachment.type)}</span>
              <ul>
                <li className="attachment-title">{attachment.button_caption}</li>
                {getMediaLabel(attachment)}
              </ul>
              <span className='pull-right chevron'><i className="fa fa-chevron-right" aria-hidden="true"></i></span>
            </a>
          </li>
        )
      })
      return attachments
    }
  }

  toggleNote(){
    // if you came from the notes index go back to the notes index
    if (this.state.goBackToNoteIndex) {
      this.props.history.push('/notes')
      // otherwise show this component again
    } else {
      this.setState({
        isTakingNotes: !this.state.isTakingNotes
      })
    }
  }

  removeEditingState() {
    this.setState({
      isTakingNotes: !this.state.isTakingNotes
    })    
  }

  getLogo(){
    var sponsor = this.state.sponsor
    if(sponsor.logo) {
      return (<img className='logo' src={sponsor.logo} alt={sponsor.name} title={sponsor.name} style={{maxHeight: '80px'}} />)
    } else {
      return (<div className="no-logo">{sponsor.name}</div>)
    }
  }

  render() {
    const {
      sponsor,
      isTakingNotes } = this.state
    const hasMedia = sponsor.attachments.length > 0 ? '' : 'hide'
    const hasNote = sponsor.note_on_sponsor ? 'has-note' : ''
    const backButton = '<i class=\'fa fa-arrow-left\'></i> ' + getLabel('back_button')
    if(!sponsor) {
      return (
        <div><a onClick={() => window.history.back()}>back</a><div>Sponsor not found.</div></div>
      )
    }
    if(!isTakingNotes) {
      return (
        <div>
          <TitleBar
            title={ sponsor.name }
            leftButtonLabel={ backButton }
            leftButtonAction={ () => window.history.back() } />
          <div className='sponsor-page'>
            { this.getLogo() }
            <div className='sponsor-actions'>
              <button className={hasNote} onClick={this.toggleNote.bind(this)} >
                <i className="fa fa-sticky-note-o"></i> {getLabel('note')}
              </button>
              <br />
              <button className='website external-link'>
                <a href={sponsor.url} target='_blank' rel='noopener noreferrer'><i className='fa fa-external-link'></i> {getLabel('visit_website')}</a>
              </button>
              <br />
            </div>
            <br />
            <div key="sponsor_description_header">
              <span className="blue-header">
                <h4 key="sponsor_description">{getLabel('description')}</h4>
              </span>
            </div>
            <p dangerouslySetInnerHTML={{__html: sponsor.description}} ></p>
            {this.getContacts()}
            <br /><br />
            <div className={'media-section ' + hasMedia}>
              <span className="blue-header">
                <h4 key="sponsor_attachment">{getLabel('media')}</h4>
              </span>
              <ul>
                {this.getMedia()}
              </ul>
            </div>
          </div>
          <pre className="debug-json">{JSON.stringify(sponsor, false, 2)}</pre>
        </div>
      )
    } else {
      return (
        <NoteForm
          postResource={ this.props.postResource }
          note={ sponsor.note_on_sponsor }
          sponsorName={ sponsor.name }
          toggleNote={ this.toggleNote }
          flashMessage={ this.props.flashMessage }
          noteType={ 'sponsorNote' }
          postData={{ sponsor_id: sponsor.id }} >
          <div className='sponsor-logo' onClick={() => {this.removeEditingState()}} >
            { this.getLogo() }
            <br /><br />
          </div>
        </NoteForm>
      )
    }
  }
}
